import { IRefIds } from 'constants/refs';
import { del, get, post } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IAIIllustrationCreate, IAIIllustrationEdit, IAIIllustrationListItem } from 'types/aiIllustration';

export type IAIIllustrationModelOptions = IModelOptions;

export class AIIllustrationModel extends BaseModel<IAIIllustrationListItem, IAIIllustrationEdit> {
  constructor(options: IAIIllustrationModelOptions) {
    super(options);
    this.ref = IRefIds.aiIllustration;
    this.gridName = 'AIIllustration';
    this.getGridColumns();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<IAIIllustrationListItem[]>(`/ai-illustration/jobs`);
    this.loadingGrid = false;
    this.render();
  }

  async getGridRow(itemId: number) {
    return await get<IAIIllustrationListItem>(`/ai-illustration/jobs/${itemId}`);
  }

  async createJob(data: IAIIllustrationCreate) {
    const response = await post<{ id: number; message?: string }>(`/ai-illustration/jobs`, data);
    await this.getGrid();
    return response;
  }

  async delete() {
    await del(`/ai-illustration/jobs/${this.itemId}`);
    this.itemId = -1;
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return await get<IAIIllustrationEdit>(`/ai-illustration/jobs/${itemId}`);
  }
}
